import "./App.css";
import {
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { PrivateRoute } from "./Navigator/PrivateRoute";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ff9800",
    },
    secondary: {
      main: "#388e3c",
    },
    typography: {
      fontFamily: "Arial",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <PrivateRoute path="/" />
        </Switch>
      </Router>
    </ThemeProvider>
  );
}

export default App;
